/* eslint-disable max-len */

import React, { useMemo } from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import SmsPrice from 'components/price/SmsPrice.component';
import { useTranslation } from 'providers/GILT.provider';

const Text = () => {
  const { t } = useTranslation();
  return (
    <div>
      {t('staffAndBusiness.subAndBilling.pricePlan.feature16Part1')}
      <br />
      {t('staffAndBusiness.subAndBilling.pricePlan.feature16Part2')}
    </div>
  );
};

const SmsPriceText = () => {
  const { t } = useTranslation();

  return (
    <div>
      {t('staffAndBusiness.subAndBilling.pricePlan.feature18TipPart1')} <CurrencySign />
      <SmsPrice /> {t('staffAndBusiness.subAndBilling.pricePlan.feature18TipPart2')}
    </div>
  );
};

const determinePricePlanFeatures = (t) => [
  {
    id: 1,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature1'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature1Tip'),
    link: 'https://www.getslick.com/calendar',
  },
  {
    id: 2,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature2'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature2Tip'),
    link: 'https://www.getslick.com/www.getslick.com/clients',
  },
  {
    id: 3,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature3'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature3Tip'),
    link: '',
  },
  {
    id: 4,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature4'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature4Tip'),
    link: 'https://www.getslick.com/www.getslick.com/reports',
  },
  {
    id: 5,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature5'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature5Tip'),
    link: 'https://www.getslick.com/www.getslick.com/marketing',
  },
  {
    id: 6,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature6'),
  },
  {
    id: 7,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature7'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature7Tip'),
    link: 'https://www.getslick.com/etraining-stock',
  },
  {
    id: 8,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature8'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature8Tip'),
    link: '',
  },

  {
    id: 9,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature9'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature9Tip'),
    link: 'https://www.getslick.com/online-booking',
  },
  {
    id: 10,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature10'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature10Tip'),
    link: 'https://www.getslick.com/slick-bookings-for-instagram',
  },
  {
    id: 11,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature11'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature11Tip'),
    link: 'https://www.getslick.com/online-payments',
  },
  {
    id: 12,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature12'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature12Tip'),
    link: 'https://www.getslick.com/online-payments',
  },
  {
    id: 13,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature13'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature13Tip'),
    link: 'https://www.getslick.com/online-payments',
  },
  {
    id: 14,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature14'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature14Tip'),
    link: '',
  },
  {
    id: 15,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature15'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature15Tip'),
    link: 'https://www.getslick.com/education',
  },
  {
    id: 16,
    text: <Text />,
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature16Tip'),
    link: 'https://www.getslick.com/education',
  },
  {
    id: 17,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature17'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature17Tip'),
    link: 'https://www.getslick.com/www.getslick.com/textreminders',
  },

  {
    id: 18,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature18'),
    tooltip: <SmsPriceText />,
    link: 'https://www.getslick.com/digital-appointment-cards',
  },
  {
    id: 19,
    text: t('staffAndBusiness.subAndBilling.pricePlan.feature19'),
    tooltip: t('staffAndBusiness.subAndBilling.pricePlan.feature19Tip'),
    link: 'https://www.getslick.com/www.getslick.com/marketing',
  },
];

const PricePlanFeatures = () => {
  const { t } = useTranslation();

  const pricePlanFeatures = useMemo(() => determinePricePlanFeatures(t), [t]);

  return (
    <ul>
      {pricePlanFeatures.map((feature) => (
        <li key={feature.id}>
          <a href={feature.link} target="_blank" rel="noopener noreferrer">
            {feature.text}
          </a>
          {feature.tooltip && (
            <div className="client-info-icon">
              <span className="tooltip">
                <div className="tooltip-centered">{feature.tooltip}</div>
              </span>
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};

export default PricePlanFeatures;
